import { loadAboutData } from '@/redux/modules/about.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return dispatch(loadAboutData());
};
